import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import 'brace/mode/csharp';
import { Observable } from 'rxjs/Observable';
import { RuleService } from 'app/infrastructure/services/reglas.service';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { ProductFlowService, FlowRulePostRequest } from 'app/infrastructure/services/productFlow.service';
import { CacheService } from 'app/infrastructure/services/cache.service';
import { DesignerCachableOutput, DesignerCachableInputs } from 'app/private/sxfdesigner/types/designer-context-type';
import { Rule, RuleComponent, TryCompileRequest } from 'app/infrastructure/model/interfaces/rule.interface';
import { RuleCompilationResult } from 'app/infrastructure/model/classes/rule.class';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';

@Component({
  templateUrl: './interactionEvent.component.html',
  styleUrls: ['./interactionEvent.component.css']
})

export class IntaractionEventComponent implements OnInit {
  regla: Rule = {
    idRegla: '',
    codServicio: 'SrvDynFormEngin',
    codReglaEvento: '',
    codComando: '',
    textoRegla: '',
    comentario: '',
    versionActual: 1,
    ultimaVersion: 1
  };

  codRegla = '';
  codSistema = '';
  codNegocio = '';
  codProducto = '';
  codCommand = '';
  codFlow = '';
  documentKind = '';
  eventType = '';
  codPage = '';
  standardKey = null;

  text = '';

  compilationResult: RuleCompilationResult;

  options: any = { maxLines: 1000, printMargin: true };
  comentario: string;
  componentes: RuleComponent[] = [];

  isNew = false;

  request: FlowRulePostRequest = {
    rule: null,
    level: null,
  };

  isDesignerCreated = false;
  designerContext: DesignerCachableOutput;
  renderComponents: boolean = false;
  showErrors: boolean = false;
  isNonTransactional: boolean;
  flowId: string;

  constructor(private aRoute: ActivatedRoute,
    public loader: LoaderService,
    private reglasService: RuleService,
    private prodFlowService: ProductFlowService,
    private nonTransactionalService : NonTransactionalFlowService,
    private alert: AlertService,
    private alertService: AlertService,
    private cacheService: CacheService,
    private router: Router) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.codCommand = params['codCommand'];
      this.codFlow = params['codFlow'];
      this.documentKind = params['documentKind'];
      this.eventType = params['eventType'];
      this.codPage = params['codPage'];

      this.flowId = params['flowId']; //non transactional

      if (this.codSistema === undefined) {
        this.codSistema = null;
      }
      if (this.codNegocio === undefined) {
        this.codNegocio = null;
      }
      if (this.codNegocio === undefined) {
        this.codProducto = null;
      }

      this.isNonTransactional = this.router.url.includes('nontransactionalflows');

      if (this.codCommand === 'NewRule') {
        this.isNew = true;
        this.reglasService.getComponentes(this.eventType, 'SrvDynFormEngin')
          .then(componentes => this.componentes = componentes);
      } else {
        this.isNew = false;
        if(this.isNonTransactional){
          this.nonTransactionalService.getInteractionEventByCode(this.flowId,this.codCommand)
                .subscribe(regla => {
                  this.regla = regla;
                  this.codSistema = '*';
                  this.text = this.regla.textoRegla;
                  this.comentario = this.regla.comentario;
                  this.reglasService.getComponentes(this.eventType, 'SrvDynFormEngin')
                    .then(componentes => this.componentes = componentes);
                });
        }else{
          if(this.codSistema == null)
          {
            this.prodFlowService.getRuleByContextForStandard(this.eventType, this.codCommand, this.codFlow, this.standardKey, this.codPage )
              .subscribe(regla => {
                this.regla = regla;
                this.codSistema = '*';
                this.text = this.regla.textoRegla;
                this.comentario = this.regla.comentario;
                this.reglasService.getComponentes(this.eventType, 'SrvDynFormEngin')
                  .then(componentes => this.componentes = componentes);
              });
          }
          else
          {
              this.prodFlowService.getRuleByContext(
                this.codSistema, this.codNegocio, this.codProducto, this.eventType, this.codCommand, this.codFlow, this.codPage
              )
                .subscribe(regla => {
                  this.regla = regla;
                  this.text = this.regla.textoRegla;
                  this.comentario = this.regla.comentario;
                  this.reglasService.getComponentes(this.eventType, 'SrvDynFormEngin')
                    .then(componentes => this.componentes = componentes);
                });
            }
        }
      }
    });

    this.designerContext = this.cacheService.getDesignerOutputs();
    if (!this.designerContext) {
      this.isDesignerCreated = false;
    } else {
      this.isDesignerCreated = true;
    }

  }

  showComponents(){
    this.renderComponents = !this.renderComponents
  }

  tryCompile() {
    const tryCompileData: TryCompileRequest = {
      ruleId: this.regla.idRegla,
      ruleCode: this.text,
      systemCode: this.codSistema,
      businessCode: this.codNegocio,
      productCode: this.codProducto,
    };
    this.reglasService.tryCompile(tryCompileData).subscribe(
      data => {
        this.compilationResult = data.compileResult;
        if (data.compileResult.isOk()) {
          this.alertService.showGrowl({
            body: 'RULE_COMPILED_SUCCESSFULLY',
            type: GrowlType.SUCCESS,
          });
        }
      }
    );
  }

  guardar(saveAndClose:boolean) {
    if (this.codRegla === 'NewRule') {
      this.alert.showGrowl({
        type: GrowlType.WARNING,
        body: 'INVALID_NAME',
      });
      return;
    }

    this.compilationResult = undefined;
    this.regla.textoRegla = this.text;
    this.regla.comentario = this.comentario;
    this.regla.codReglaEvento = this.eventType;

    this.request.rule = this.regla;
    this.request.level = {
      codInstalacionV5: this.codSistema,
      codNegocio: this.codNegocio,
      codProducto: this.codProducto,
      standardkey: this.standardKey,
      codFlow: this.codFlow,
      idOpcionNegocio: null,
      idRegla: null,
    };

    if(!this.isNonTransactional){
      this.prodFlowService.createOrUpdateRule(this.request)
      .then(regla => {
        this.alertService.showSuccessMessage('INTERACTION_RULE_CREATED');
        if (!this.isDesignerCreated && saveAndClose === true) {
          this.router.navigate(['../../'], { relativeTo: this.aRoute });
        } else {
          this.regla = regla;
          this.isNew = false;
          this.text = this.regla.textoRegla;

          // removes inputs if any
          this.cacheService.removeDesignerInputs();
          const rulecodes: DesignerCachableInputs = {
            storedRuleCode: this.codRegla
          };
          this.cacheService.setDesignerInputs(rulecodes);

          // the outputs are not needed, so they need to go away as well
          this.cacheService.removeDesignerOutputs();

          if (this.designerContext.storedContext.listPath) {
            this.router.navigate(['../../../', 'sxfDesigner', this.designerContext.storedContext.pageId,
              this.designerContext.storedContext.listPath],
              { relativeTo: this.aRoute });
          } else {
            this.router.navigate(['../../../', 'sxfDesigner', this.designerContext.storedContext.pageId],
              { relativeTo: this.aRoute });
          }
        }
      });
    }else{
      this.nonTransactionalService.createOrUpdateInteractionEvent(this.flowId,this.request)
      .then(regla => {
        this.alertService.showSuccessMessage('INTERACTION_RULE_CREATED');
        if (!this.isDesignerCreated) {
          this.router.navigate(['../../'], { relativeTo: this.aRoute });
        } else {
          this.regla = regla;
          this.isNew = false;
          this.text = this.regla.textoRegla;

          // removes inputs if any
          this.cacheService.removeDesignerInputs();
          const rulecodes: DesignerCachableInputs = {
            storedRuleCode: this.codRegla
          };
          this.cacheService.setDesignerInputs(rulecodes);

          // the outputs are not needed, so they need to go away as well
          this.cacheService.removeDesignerOutputs();

            this.router.navigate(['../../../', 'sxfDesigner', this.designerContext.storedContext.pageId],
              { relativeTo: this.aRoute });
        }
      });
    }
  }

  openSourceCodeTab(error) {
    const wnd = window.open('', '_blank');
    wnd.document.write(JSON.stringify(error));
    wnd.document.title = 'RULE_EXCEPTION_IN: '+this.regla.idRegla;
    window.focus();
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/dynamicFlow/IterationEventComponent/interactionEvent.component.ts